export default __webpack_public_path__ + "static/media/12.a9dfc135.jpg";